import { needsStandalonePageBreak, handoutBreakIsEnabled } from "./handoutPagination";

// Measure the same CSS columns used by the preview; do not infer pages from
// question counts. Empty formatting markers still have a useful horizontal box.
export const measureHandoutBreakPages = (flow, sections, settings, stride) => {
  const result = {};
  const bounds = flow?.getBoundingClientRect();
  const scale = flow?.offsetWidth > 0 ? bounds.width / flow.offsetWidth : 0;
  const positions = new Map();
  if (scale > 0 && stride > 0) {
    for (const node of flow.querySelectorAll("[data-handout-section-id]")) {
      const id = node.getAttribute("data-handout-section-id");
      const rect = Array.from(node.getClientRects()).find((rect) => rect.width > 0 && Number.isFinite(rect.left));
      if (rect && !positions.has(id)) positions.set(id, Math.max(1, Math.floor((rect.left - bounds.left) / scale / stride + .01) + 1));
    }
  }
  sections.forEach((section, index) => {
    if (!["page_break", "section_break"].includes(section.type)) return;
    if (!needsStandalonePageBreak(section, index, sections, settings)) {
      result[section.id] = { status: "skipped", reason: !handoutBreakIsEnabled(section, settings) ? "連續排版" : "與前一分界合併" };
    } else {
      const page = positions.get(String(section.id));
      result[section.id] = page ? { status: "measured", page } : { status: "pending" };
    }
  });
  return result;
};

export const handoutBreakPageLabel = (section, measurement) => {
  if (measurement?.status === "skipped") return `目前略過（${measurement.reason}）`;
  if (measurement?.status === "measured") return `第 ${measurement.page} 頁${section.type === "section_break" ? "開始新節" : "開始"}`;
  return "頁數計算中…";
};
